import { useEffect, useRef, useState } from "react";
import { Divider, Modal, Upload, Form, Row, Input, Spin } from "antd";
import MyButton from "./Button";
import Typography from "./Typography";
import { COLORS } from "../constants/Colors";
import useIsDesktop from "../utils/hooks/useIsDesktop";
import Resizer from "react-image-file-resizer";
import { imageFileResizer } from "react-image-file-resizer";
import "./Customer.css";
// import { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import {
  CameraOutlined,
  CloseOutlined,
  FileImageOutlined,
  LoadingOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { Avatar } from "antd";
import MyInput from "./Input";
import { CORPORATE_TYPE, INDIVIDUAL_TYPE } from "../constants";
import _ from "lodash";
import GetProfile from "./VariableStore";
import { instance } from "./AxiosClient";
import { Notification } from "./Notification";
import DefaultProfile from "../../src/assets/Profile_Default.png";
import { instanceImg } from "./Axiosimg";
import UserProfileconfirmModal from "./UserProfileconfirmModal";

const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
};

const { Item } = Form;
let fileHashes = [];

const UserProfileModal = (props) => {
  const { isOpen, onCancle, setTrigger } = props;
  const intl = useIntl();
  const isDesktop = useIsDesktop();
  const imageRef = useRef();
  const [form] = Form.useForm();
  const [isEdit, setIsEdit] = useState(false);
  const [isset, setIsSet] = useState(false);
  const [imageCustomer, setImageCustomer] = useState();
  const [imageCustomerDoc, setImageCustomerDoc] = useState();
  const [fileHashDoc, setFileHashDoc] = useState();
  const [getDoc, setImageGetDoc] = useState();
  const [imageFileDefault, setImageFileDefault] = useState("");
  const [fileList, setFileList] = useState([]);
  const [profileData, setProfileData] = useState();
  // const [changeType, setChangeType] = useState();
  const [customerName, setCustomerName] = useState();
  const [taxNo, setTaxNo] = useState();
  const [contacts, setContacts] = useState();
  const [phone, setPhone] = useState();
  const [email, setEmail] = useState();
  const [imageFile, setImageFile] = useState();
  const customerId = GetProfile("customerId");
  const comCode = GetProfile("customerCode");
  const [imageFilefalse, setImageFilefalse] = useState();
  // const isCorporateType = changeType !== "บุคคลธรรมดา";
  const [isCorporateType, setIsCorporateType] = useState(false)
  const [imageUrl, setImageUrl] = useState();
  const [isloading, setIsloading] = useState(false);
  const [isOpenConfirm, setIsOpenConfirm] = useState(false);
  const [spinning, setSpinning] = useState(false)

  const onFinish = (values) => {
    form
      .validateFields()
      .then(() => {
        handleUpdated();
      })
      .catch((errorInfo) => {
        handleCloseConfirm();
      });
  };

  const handleClickEdit = () => {
    setIsEdit(true);
    setIsSet((prev) => !prev);
  };

  const showNameAndContact = (name) => { };

  const handleCancle = () => {
    setImageFile();
    setImageUrl();
    setIsEdit(false);
    onCancle();
  };

  const handleClickCancelEdit = () => {
    if (isEdit) {
      form.resetFields(); // Reset the form fields to their initial values
    } else {
      form.setFieldsValue({ companyName: profileData?.customerName }); // Set initial value
    }
    setIsEdit(!isEdit);
  };

  const handleOpenConfirm = () => {
    setIsOpenConfirm(true);
  };
  const handleCloseConfirm = () => {
    setIsOpenConfirm(false);
  };

  const handleisloading = () => {
    setIsloading(true);
  };
  const handleCloseisloading = () => {
    setIsloading(false);
  };

  const handleUpdated = async () => {
    handleisloading();
    handleCloseConfirm();
    try {
      // Prepare the data to send to the server
      let updatedData = {};
      if (isCorporateType) {
        updatedData = {
          customerName: `${customerName} • ${contacts}`,
          taxNo,
          phone,
          email: email,
          corporateContact: contacts
        };
      } else {
        updatedData = {
          customerName: `${customerName}`,
          taxNo,
          phone,
          email: email,
        };
      }

      const response = await instance.put(
        `/v3/business-partner/manager/company/${comCode}/customer-informations/${customerId}`,
        updatedData
      );
      if (imageCustomer !== undefined) {
        let formData = new FormData();
        formData.append("file", imageCustomer);
        //console.log("formData==", formData);
        const responseimg = await instanceImg.put(
          `/v3/business-partner/manager/company/${comCode}/customer-informations/${customerId}`,
          formData
        );
      }
      if (imageCustomerDoc !== undefined) {
        const formDataArray = imageCustomerDoc.map((imageData) => {
          const formData = new FormData();
          formData.append("file", imageData.imageCustomerDoc);
          return formData;
        });

        await Promise.all(
          formDataArray.map((formData) =>
            instanceImg.post(
              `/v5/business-partner/manager/company/${comCode}/web/document/juristicpp20`,
              formData
            )
          )
        );
        getProfile();
      }

      if (fileHashes.length > 0) {
        try {
          const promises = fileHashes.map((fileHash) => {
            return instance.delete(
              `/v5/business-partner/manager/company/${comCode}/web/document/juristicpp20/${fileHash}`
            );
          });
          const responses = await Promise.all(promises);
        } catch (error) { }
      }
      setTrigger((cur) => !cur);
      setIsEdit(false);
      getProfile();
      handleCloseisloading();
      onCancle();
      setImageCustomerDoc();
      Notification("success",intl.formatMessage({ id: 'notificationEditProfileSuccess', defaultMessage: "Edit profile successfully" }) );
    } catch (error) {
      Notification("error",intl.formatMessage({ id: 'notificationEditProfileFail', defaultMessage: "Edit profile fail!" }) );
      onCancle();
      setIsEdit(false);
      handleCloseisloading();
    }
  };

  const [type, setType] = useState(CORPORATE_TYPE);

  //const isCorporateType = type === CORPORATE_TYPE;

  const handleChangeType = () => {
    const newType = isCorporateType ? INDIVIDUAL_TYPE : CORPORATE_TYPE;
    setType(newType);
  };

  const getProfile = async () => {
    setSpinning(true)
    try {
      const response = await instance.get(
        `/v3/business-partner/manager/company/${comCode}/customer-informations/${customerId}`
      );
      setProfileData(response?.data?.data);
      _.get(response, "data.data.juristicPP20Docs");
      setImageGetDoc(response?.data?.data?.juristicPP20Docs);
      setImageFilefalse(response?.data?.data?.juristicPP20Docs);
      setIsCorporateType(response?.data?.data?.customerType?.customerTypeName !== "บุคคลธรรมดา");
      setIsloading(false);
    } catch (error) { }
    setSpinning(false)
  };

  const showOpenFileDialog = (e) => {
    imageRef.current.click();
  };

  const resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        720,
        720,
        "JPEG",
        70,
        0,
        (uri) => {
          resolve(uri);
        },
        "base64"
      );
    });

  const dataURLtoFile = (dataurl, filename) => {
    const arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    for (var i = 0; i < bstr.length; i++) {
      u8arr[i] = bstr.charCodeAt(i);
    }
    return new File([u8arr], filename, { type: mime });
  };

  const handleChangePicture = async (event) => {
    event.preventDefault();
    let reader = new FileReader();
    const file = event.target.files[0];

    if (file) {
      if (file.name.match(/\.(jpg|jpeg|png|JPG|PNG|JPEG)$/)) {
        const image = await resizeFile(file);
        reader.onloadend = () => {
          const image = reader.result;
          setImageFile(image);
        };
        reader.readAsDataURL(file);

        const fileChange = dataURLtoFile(image, file.name);
        setImageCustomer(fileChange);
      }
    }
  };

  const handleChangeDoc = async (info) => {
    const newFileList = [...info.fileList];
    const processedImages = [];
    const processedImagesFile = [];

    for (const file of newFileList) {
      try {
        const resizedImage = await resizeImage(file.originFileObj, 2000); // Resize image to less than 500 kB
        getBase64(resizedImage, (url) => {
          processedImages.push({
            imageCustomerDoc: resizedImage,
            imageUrl: url,
          });
          processedImagesFile.push({
            uid: file.uid,
            name: "image.png",
            status: "done",
            url: url,
          });

          if (processedImages.length === newFileList.length) {
            setImageCustomerDoc(processedImages);
            setFileList(processedImagesFile);
            setFileHashDoc(processedImagesFile);
          }
        });
      } catch (error) {
        console.error("Error resizing image:", error);
      }
    }
  };

  const resizeImage = (img, maxSizeKB) => {
    return new Promise((resolve, reject) => {
      const imgQuality = 0.8; // You can adjust the image quality if needed
      const reader = new FileReader();

      reader.onload = (event) => {
        const imgDataUrl = event.target.result;
        const imgElement = new Image();

        imgElement.onload = () => {
          const canvas = document.createElement("canvas");
          const aspectRatio = imgElement.width / imgElement.height;
          let newWidth = Math.sqrt(maxSizeKB * 1024 * aspectRatio);
          let newHeight = newWidth / aspectRatio;

          if (newWidth > imgElement.width) {
            newWidth = imgElement.width;
            newHeight = imgElement.height;
          }

          canvas.width = newWidth;
          canvas.height = newHeight;

          const ctx = canvas.getContext("2d");
          ctx.drawImage(imgElement, 0, 0, newWidth, newHeight);

          canvas.toBlob(
            (blob) => {
              const resizedFile = new File([blob], img.name, {
                type: "image/jpeg", // Change the type as needed (jpeg, png, etc.)
                lastModified: Date.now(),
              });
              resolve(resizedFile);
            },
            "image/jpeg",
            imgQuality
          );
        };

        imgElement.onerror = (error) => {
          reject(error);
        };

        imgElement.src = imgDataUrl;
      };

      reader.onerror = (error) => {
        reject(error);
      };

      reader.readAsDataURL(img);
    });
  };

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </div>
  );

  const removeDoc = (fileHash, index) => {
    const comCode = GetProfile("customerCode");
    const deletedImages = [...fileHashDoc];
    if (index >= 0 && index < deletedImages.length) {
      deletedImages.splice(index, 1);
      fileHashes.push(fileHash.fileHash);
      setFileHashDoc(deletedImages);
      setImageCustomerDoc(undefined);
    } else {
      console.error("Invalid index provided");
    }
  };

  useEffect(() => {
    setImageGetDoc(_.get(profileData, "juristicPP20Docs"));
    setImageFile(_.get(profileData, "profileImg"));
    setImageFileDefault(DefaultProfile);
    form.setFieldsValue({
      email: profileData?.contacts[0]?.customerContactEmail,
    });
    form.setFieldsValue({ emailCustomer: profileData?.email });
    form.setFieldsValue({ phoneNumber: profileData?.phone });
    form.setFieldsValue({
      companyName: profileData?.customerName.split("•")[0],
    });
    form.setFieldsValue({
      contact: profileData?.customerName.split("•")[1],
    });
  }, []);

  useEffect(() => {
    if (customerId && (isOpen || isEdit || isset)) {
      getProfile();
      setFileHashDoc(_.get(profileData, "juristicPP20Docs"));
      setImageGetDoc(_.get(profileData, "juristicPP20Docs"));
      setImageFile(_.get(profileData, "profileImg"));
      setEmail(profileData?.email);
      setPhone(profileData?.phone);
      setContacts(profileData?.customerName.split("•")[1]);
      setCustomerName(profileData?.customerName.split("•")[0]);

      form.setFieldsValue({ email: profileData?.email });
      form.setFieldsValue({ phoneNumber: profileData?.phone });
      form.setFieldsValue({
        companyName: profileData?.customerName.split("•")[0],
      });
      form.setFieldsValue({
        contact: profileData?.customerName.split("•")[1],
      });

      setImageCustomerDoc();
      setFileList();
      setImageCustomer(undefined);
      fileHashes = [];
    }
  }, [isOpen, isEdit, isset, customerId]);

  return (
    <>
      <Modal
        title={
          <Typography
            color={COLORS.Primary}
            isBold
            size="16px"
            className={isDesktop ? "pb-3" : "text-center pb-2"}
          >
            <FormattedMessage id="profile" defaultMessage="profile" />
          </Typography>
        }
        centered={isDesktop ? true : false}
        open={isOpen}
        onOk={() => { }}
        onCancel={handleCancle}
        width={680}
        footer={
          <>
            {isDesktop ? (
              <div
                style={{
                  display: "flex",
                  marginLeft: "63%",
                  marginTop: "20px",
                }}
              >
                <MyButton
                  onClick={isEdit ? handleClickCancelEdit : handleCancle}
                  style={{
                    width: "55%",
                  }}
                >
                  <FormattedMessage id="btnCancel" defaultMessage="Cancel" />
                </MyButton>
                <MyButton
                  isPrimary
                  style={{
                    width: "60%",
                    marginLeft: '10px'
                  }}
                  onClick={isEdit ? handleOpenConfirm : handleClickEdit}
                >
                  {isloading === true ? <LoadingOutlined /> : null}
                  {isEdit ? (
                    <FormattedMessage id="btnSave" defaultMessage="Save" />
                  ) : (
                    <FormattedMessage id="btnEdit" defaultMessage="Edit" />
                  )}
                </MyButton>
              </div>
            ) : (
              <div>
                <div style={{ marginBottom: "4px" }}>
                  <MyButton
                    isPrimary
                    style={{
                      width: "100%",
                      height: "20%",
                    }}
                    onClick={isEdit ? handleOpenConfirm : handleClickEdit}
                  >
                    {isloading === true ? <LoadingOutlined /> : null}
                    {isEdit ? (
                      <FormattedMessage id="btnSave" defaultMessage="Save" />
                    ) : (
                      <FormattedMessage id="btnEdit" defaultMessage="Edit" />
                    )}
                  </MyButton>
                </div>
                <div style={{ marginTop: "4px" }}>
                  <MyButton
                    onClick={isEdit ? handleClickCancelEdit : handleCancle}
                    style={{
                      width: "100%",
                    }}
                  >
                    <FormattedMessage id="btnCancel" defaultMessage="Cancel" />
                  </MyButton>
                </div>
              </div>
            )}
          </>
        }
      >
        <Spin spinning={spinning}>
          <Divider className="m-0" />
          <Form form={form} onFinish={handleOpenConfirm}>
            <div
              className={`d-flex ${isDesktop ? "flex-row" : "flex-column"
                } p-4 m-2`}
            >
              <div
                className={`d-flex flex-column ${isDesktop ? "" : "align-items-center"
                  }`}
              >
                <div
                  style={{
                    position: "relative",
                    display: "inline-block",
                    marginBottom: "3%",
                  }}
                >
                  <Avatar
                    size={160}
                    sx={{
                      width: 160,
                      height: 160,
                      "& img": {
                        borderRadius: "50%",
                      },
                    }}
                    alt="Profile Avatar"
                    src={imageFile ? imageFile : _.get(profileData, "profileImg")}
                  />
                  {isEdit ? (
                    <div
                      style={{
                        position: "absolute",
                        bottom: 3,
                        right: 1,
                        width: "45px",
                        backgroundColor: `${COLORS.Primary}`,
                        borderRadius: "50%",
                        borderStyle: "solid",
                        borderColor: "#fff",
                        borderWidth: 4,
                        padding: 8,
                        cursor: "pointer",
                      }}
                      onClick={showOpenFileDialog}
                    >
                      <CameraOutlined
                        style={{
                          color: "#fff",
                          marginLeft: "2px",
                          marginTop: "3px",
                          fontSize: "18px",
                        }}
                      />
                    </div>
                  ) : null}
                </div>

                <input
                  ref={imageRef}
                  type="file"
                  style={{ display: "none" }}
                  accept=".jpg, .png, .JPG, .PNG"
                  onChange={handleChangePicture}
                />
                {isEdit ? (
                  <div
                    className="image-container after"
                    style={{ paddingTop: 10, paddingLeft: 32, paddingRight: 12 }}
                  ></div>
                ) : null}
              </div>
              <div
                className={`d-flex flex-column align-items-start ${isDesktop ? "pl-5 w-75" : "w-100"
                  }`}
                style={{ marginTop: isDesktop ? "0px" : "20px" }}
              >
                <Typography
                  isBold
                  color={COLORS.Primary}
                  style={{ marginBottom: isEdit ? "6px" : "0px" }}
                >
                  {isCorporateType ? (
                    <FormattedMessage
                      id="companyName"
                      defaultMessage="Company Name"
                    />
                  ) : (
                    <FormattedMessage id="labelName" defaultMessage="Name" />
                  )}
                  {isEdit ? (
                    <span style={{ fontSize: "13px", color: "#ff0000" }}> *</span>
                  ) : null}
                </Typography>
                <Item
                  name="companyName"
                  initialValue={customerName}
                  className="w-100"
                  rules={[
                    {
                      required: true,
                      message: (
                        <FormattedMessage
                          id="requiredcompanyName"
                          defaultMessage="Please enter the company name"
                        />
                      ),
                    },
                  ]}
                >
                  {isEdit ? (
                    <MyInput
                      defaultValue={customerName}
                      onChange={(e) => setCustomerName(e.target.value)}
                    />
                  ) : (
                    <Typography size="15px">
                      {profileData?.customerName.split("•")[0]}
                    </Typography>
                  )}
                </Item>

                {isCorporateType === true ? (
                  <>
                    <Typography
                      isBold
                      color={COLORS.Primary}
                      style={{ marginBottom: isEdit ? "6px" : "5px" }}
                    >
                      <FormattedMessage id="taxNo" defaultMessage="Tax No." />
                    </Typography>
                    {isEdit ? (
                      <MyInput
                        className="pb-3 w-100"
                        defaultValue={profileData?.taxNo}
                        onChange={(e) => setTaxNo(e.target.value)}
                      />
                    ) : (
                      <Typography className="pb-4" size="15px">
                        {profileData?.taxNo || "-"}
                      </Typography>
                    )}

                    <Typography
                      isBold
                      color={COLORS.Primary}
                      style={{ marginBottom: isEdit ? "6px" : "0px" }}
                    >
                      <FormattedMessage
                        id="juristicDocument(PP20)"
                        defaultMessage="Juristic Document (PP20)"
                      />
                    </Typography>
                    <br />
                    {!isEdit ? (
                      _.size(getDoc) >= 1 ? (
                        <div>
                          {getDoc?.map((docUrl, index) => (
                            <div
                              className="image-container"
                              style={{
                                marginRight: "10px",
                                marginBottom: "10px",
                              }}
                            >
                              <span>
                                <img
                                  key={index}
                                  src={_.get(docUrl, "url")}
                                  alt={`Document ${index}`}
                                  width={120}
                                  height={120}
                                />
                              </span>
                            </div>
                          ))}
                        </div>
                      ) : (
                        // <FileImageOutlined style={{ fontSize: "45px" }} />
                        <div></div>
                      )
                    ) : (
                      <Row>
                        {!_.size(fileHashDoc) > 0 ? (
                          <>
                            {imageCustomerDoc !== undefined ? (
                              fileHashDoc?.map((docUrl, index) => (
                                <>
                                  <div
                                    class="image-container"
                                    style={{
                                      marginRight: "10px",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <span
                                      class="close-icon"
                                      onClick={() => removeDoc(docUrl, index)}
                                    >
                                      <CloseOutlined />
                                    </span>
                                    <span>
                                      <img
                                        key={index}
                                        src={_.get(docUrl, "url")}
                                        alt={`Document ${index}`}
                                        width={120}
                                        height={120}
                                      />
                                    </span>
                                  </div>
                                </>
                              ))
                            ) : (
                              <Upload
                                action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                                width={300}
                                height={300}
                                name="avatar"
                                listType="picture-card"
                                className="avatar-uploader"
                                accept=".jpg, .jpeg, .png"
                                //fileList={fileList}
                                //showUploadList={false}
                                disabled={imageCustomerDoc !== undefined}
                                onChange={handleChangeDoc}
                              >
                                {uploadButton}
                              </Upload>
                            )}
                          </>
                        ) : (
                          <>
                            {fileHashDoc?.map((docUrl, index) => (
                              <>
                                <div
                                  class="image-container"
                                  style={{
                                    marginRight: "10px",
                                    marginBottom: "10px",
                                  }}
                                >
                                  <span
                                    class="close-icon"
                                    onClick={() => removeDoc(docUrl, index)}
                                  >
                                    <CloseOutlined />
                                  </span>
                                  <span>
                                    <img
                                      key={index}
                                      src={_.get(docUrl, "url")}
                                      alt={`Document ${index}`}
                                      width={120}
                                      height={120}
                                    />
                                  </span>
                                </div>
                              </>
                            ))}
                            {/* <Upload           ห้ามลบ
                            width={200}
                            name="avatar"
                            listType="picture-card"
                            className="avatar-uploader"
                            accept=".jpg, .jpeg, .png"
                            //showUploadList={false}
                            onChange={handleChangeDoc}
                          >
                            {uploadButton}
                          </Upload> */}
                          </>
                        )}
                      </Row>
                    )}
                    <br />
                    {/* <Typography
                    isBold
                    color={COLORS.Primary}
                    className="pb-1 pt-2"
                    size="15px"
                  >
                    Address
                  </Typography>
                  {isEdit ? (
                    <MyInput
                      className="pb-3 w-100"
                      defaultValue={profileData?.address}
                      onChange={(e) => setAddress(e.target.value)}
                    />
                  ) : (
                    <Typography className="pb-4" size="15px">
                      {profileData?.address}
                    </Typography>
                  )} */}

                    <Typography
                      isBold
                      color={COLORS.Primary}
                      style={{ marginBottom: isEdit ? "6px" : "0px" }}
                    >
                      <FormattedMessage
                        id="labelContact"
                        defaultMessage="Contact"
                      />
                      {isEdit ? (
                        <span style={{ fontSize: "13px", color: "#ff0000" }}> *</span>
                      ) : null}
                    </Typography>
                    <Item
                      name="contact"
                      className="w-100"
                      initialValue={contacts}
                      rules={[
                        {
                          required: true,
                          message: (
                            <FormattedMessage
                              id="requiredcontacts"
                              defaultMessage="Please enter contacts"
                            />
                          ),
                        },
                      ]}
                    >
                      {isEdit ? (
                        <MyInput
                          // defaultValue={contacts}
                          defaultValue={profileData?.corporateContact}
                          onChange={(e) => setContacts(e.target.value)}
                        />
                      ) : (
                        <Typography className="pb-2" size="15px">
                          {profileData?.corporateContact || '-'} 
                          {/* {profileData?.contacts[0]?.customerContactName} */}
                          {/* {profileData?.customerName.split("•")[1]} */}
                        </Typography>
                      )}
                    </Item>
                    <Typography
                      isBold
                      color={COLORS.Primary}
                      style={{ marginBottom: isEdit ? "6px" : "0px" }}
                    >
                      <FormattedMessage
                        id="contactPhoneNumber"
                        defaultMessage="Contact Phone Number"
                      />
                      {isEdit ? (
                        <span style={{ fontSize: "15px", color: "#ff0000" }}> *</span>
                      ) : null}
                    </Typography>
                    <Item
                      className="w-100"
                      name="phoneNumber"
                      initialValue={
                        profileData?.contacts[0]?.customerContactPhone
                      }
                      rules={[
                        {
                          required: true,
                          message: (
                            <FormattedMessage
                              id="requiredcontactsPhoneNumber"
                              defaultMessage="Please enter a phone number"
                            />
                          ),
                        },
                      ]}
                    >
                      {isEdit ? (
                        <Input
                          disabled={true}
                          defaultValue={phone}
                          //onChange={(e) => setPhone(e.target.value)}
                          onKeyPress={(e) => {
                            if (
                              e.target.value.length >= 10 ||
                              !/[0-9]/.test(e.key)
                            ) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            if (
                              e.target.value.length <= 10 &&
                              /^[0-9]*$/.test(e.target.value)
                            ) {
                              setPhone(e.target.value);
                            }
                          }}
                        />
                      ) : (
                        <Typography size="15px">{profileData?.phone}</Typography>
                      )}
                    </Item>

                    <Typography
                      isBold
                      color={COLORS.Primary}
                      style={{ marginBottom: isEdit ? "6px" : "0px" }}
                    >
                      <FormattedMessage id="labelEmail" defaultMessage="Email" />
                      {isEdit ? (
                        <span style={{ fontSize: "15px", color: "#ff0000" }}> *</span>
                      ) : null}
                    </Typography>
                    <Item
                      className="w-100"
                      name="email"
                      initialValue={email}
                      rules={[
                        {
                          required: true,
                          message: (
                            <FormattedMessage
                              id="requiredEmail"
                              defaultMessage="Please enter a email address"
                            />
                          ),
                        },
                        {
                          type: "email",
                          message: (
                            <FormattedMessage
                              id="requiredTypeEmail"
                              defaultMessage="Please enter a valid email address"
                            />
                          ),
                        },
                      ]}
                    >
                      {isEdit ? (
                        <MyInput
                          defaultValue={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      ) : (
                        <Typography size="15px">
                          {profileData?.email || "-"}
                        </Typography>
                      )}
                    </Item>
                  </>
                ) : (
                  <>
                    <Typography
                      isBold
                      color={COLORS.Primary}
                      style={{ marginBottom: isEdit ? "6px" : "0px" }}
                    >
                      <FormattedMessage
                        id="labelPhone"
                        defaultMessage="Phone Number"
                      />
                      {isEdit ? (
                        <span style={{ fontSize: "15px", color: "#ff0000" }}> *</span>
                      ) : null}
                    </Typography>
                    <Item
                      className="w-100"
                      name="phoneNumber"
                      initialValue={profileData?.phone}
                      rules={[
                        {
                          required: true,
                          message: (
                            <FormattedMessage
                              id="requiredcontactsPhoneNumber"
                              defaultMessage="Please enter a phone number"
                            />
                          ),
                        },
                      ]}
                    >
                      {isEdit ? (
                        <Input
                          disabled={true}
                          defaultValue={phone}
                          //onChange={(e) => setPhone(e.target.value)}
                          onKeyPress={(e) => {
                            if (
                              e.target.value.length >= 10 ||
                              !/[0-9]/.test(e.key)
                            ) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            if (
                              e.target.value.length <= 10 &&
                              /^[0-9]*$/.test(e.target.value)
                            ) {
                              setPhone(e.target.value);
                            }
                          }}
                        />
                      ) : (
                        <Typography size="15px">{profileData?.phone}</Typography>
                      )}
                    </Item>

                    <Typography
                      isBold
                      color={COLORS.Primary}
                      style={{ marginBottom: isEdit ? "6px" : "0px" }}
                    >
                      <FormattedMessage id="labelEmail" defaultMessage="Email" />
                    </Typography>
                    <Item
                      className="w-100"
                      name="email"
                      initialValue={email}
                      rules={[
                        {
                          type: "email",
                          message: (
                            <FormattedMessage
                              id="requiredTypeEmail"
                              defaultMessage="Please enter a valid email address"
                            />
                          ),
                        },
                      ]}
                    >
                      {isEdit ? (
                        <MyInput
                          defaultValue={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      ) : (
                        <Typography size="15px">
                          {profileData?.email || "-"}
                        </Typography>
                      )}
                    </Item>
                  </>
                )}
              </div>
            </div>
          </Form>
        </Spin>
      </Modal>
      <UserProfileconfirmModal
        isOpenConfirm={isOpenConfirm}
        handleCloseConfirm={handleCloseConfirm}
        onFinish={onFinish}
        isloading={isloading}
      />
    </>
  );
};

export default UserProfileModal;
